module.exports = __webpack_public_path__ + "img/dashboard-girl.963be5fb.png";